import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { dateFormat } from 'utils/DateFormatter'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650,
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

export const ServicesTable = ({ rows, openDeleteModal }) => {
    const classes = useStyles();

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow style={{ backgroundColor: 'darkgray' }}>
                        <TableCell>Name</TableCell>
                        <TableCell>Host</TableCell>
                        <TableCell>Prefix</TableCell>
                        <TableCell>Include prefix</TableCell>
                        <TableCell>Created at</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell component="th" scope="row">
                                {row.name}
                            </TableCell>
                            <TableCell>{row.host}</TableCell>
                            <TableCell>{row.prefix}</TableCell>
                            <TableCell>{row.include_prefix ? 'Yes' : 'No'}</TableCell>
                            <TableCell>{dateFormat(row.created_at)}</TableCell>
                            <TableCell>
                                <IconButton aria-label="Delete"
                                    onClick={() => openDeleteModal(row.id)}
                                    className={classes.margin}>
                                    <DeleteIcon
                                        fontSize="small"
                                    />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                    {rows.length <= 0 &&
                        <TableRow>
                            <TableCell>
                                There are no results to display yet
                            </TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default ServicesTable